import { useQuery } from 'react-query';

import { getSubProgramPreferenceProgressScurve as queryFn } from 'api/endPoints/getSubProgramPreferenceProgressScurve';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetSubProgramPreferenceProgressScurve = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getSubProgramPreferenceProgressScurve', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.subProgramId) && Boolean(params.enabled),
    });
};

export interface QueryParams {
    subProgramId?: number;
    enabled?: boolean;
}

export type QueryResponse = 'CRITICALITY_WEIGHT_S_CURVE' | 'ACTIVITIES_COMPLETE_S_CURVE' | 'RESOURCE_UNITS_S_CURVE';
